<template>
  <div>
    <div class="panel-header">
      <div>
        <div class="panel-title">权限SQL测试</div>
        <div class="panel-desc">
          指定用户+业务表，生成数据权限SQL片段（岗位默认权限+用户特殊权限合并取并集，口径与运行时链路一致）
        </div>
      </div>
    </div>

    <a-card :bordered="false" class="test-card">
      <a-form-model layout="inline">
        <a-form-model-item label="用户">
          <user-select v-model="userId" @select="onUserSelect" />
        </a-form-model-item>
        <a-form-model-item label="业务表">
          <a-select
            v-model="tableName"
            show-search
            allow-clear
            option-filter-prop="children"
            placeholder="选择或输入表名"
            style="width: 260px"
          >
            <a-select-option v-for="item in tableOptions" :key="item" :value="item">
              {{ item }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item>
          <a-button type="primary" :disabled="!userId || !tableName" :loading="testing" @click="test">
            生成SQL
          </a-button>
        </a-form-model-item>
      </a-form-model>

      <a-divider style="margin: 8px 0 16px" />

      <template v-if="result !== null">
        <div class="result-label">
          <a-icon type="check-circle" theme="two-tone" two-tone-color="#52c41a" />
          生成的SQL片段（拼接到业务SQL的where子句后）
        </div>
        <pre class="sql-box">{{ result }}</pre>
        <div class="result-tip">
          说明：" and 1=1 " 表示无过滤（全部数据）；" and 1&lt;&gt;1 " 表示拒绝访问（无岗位或未配置权限）
        </div>
      </template>
      <a-empty v-else description="选择用户和业务表后点击「生成SQL」" style="margin-top: 48px" />
    </a-card>
  </div>
</template>

<script>
import { testDataPermissionSql, fetchDataPermissionList } from "@/api/setting/auth";
import UserSelect from "./user-select";

export default {
  name: "sql-test",

  components: { UserSelect },

  data() {
    return {
      userId: undefined,
      userName: "",
      tableName: undefined,
      testing: false,
      result: null,
      dpList: [],
    };
  },

  computed: {
    // 从权限定义中提取去重的业务表名作为候选
    tableOptions() {
      const set = new Set();
      this.dpList.forEach((item) => {
        if (item.tableName) {
          set.add(item.tableName);
        }
      });
      return Array.from(set).sort();
    },
  },

  mounted() {
    fetchDataPermissionList()
      .then((res) => {
        this.dpList = Array.isArray(res) ? res : [];
      })
      .catch(() => {});
  },

  methods: {
    onUserSelect(user) {
      this.userName = user ? user.name : "";
    },
    test() {
      this.testing = true;
      testDataPermissionSql({ userId: this.userId, tableName: this.tableName })
        .then((res) => {
          this.result = typeof res === "string" ? res : JSON.stringify(res, null, 2);
        })
        .catch(() => {
          this.result = null;
        })
        .finally(() => {
          this.testing = false;
        });
    },
  },
};
</script>

<style scoped>
.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;
}
.panel-title {
  font-size: 16px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
}
.panel-desc {
  margin-top: 4px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
}
.test-card {
  border: 1px solid #f0f0f0;
  border-radius: 4px;
}
.result-label {
  margin-bottom: 8px;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.65);
}
.sql-box {
  background: #0d1a26;
  color: #7fdbff;
  padding: 16px;
  border-radius: 4px;
  font-family: Consolas, Monaco, "Courier New", monospace;
  font-size: 13px;
  line-height: 1.7;
  word-break: break-all;
  white-space: pre-wrap;
  margin: 0;
}
.result-tip {
  margin-top: 8px;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
}
</style>
